import { CashbackType } from "@domain/Carbucks";
import { ActiveVehicle, AppMode, useApi, type IActiveVehicle, type IActiveVehicleDto, type IUser, type IUserDto } from ".";
import type { IDealerModeRole } from "./IDealerModeRole";
import { DealerModeRole } from "./DealerModeRole";

export function useUser(): IUser
{
    const api = useApi();
    return api.user.value!;
}

export class User implements IUser
{

    appConsumerId: string;
    businessConsumerId: string;
    businessId: string;
    businessName: string;
    appName: string;
    firstName: string;
    lastName: string;
    email?: string;
    permissions: string[];
    activeVehicle: IActiveVehicle;
    appMode: AppMode = AppMode.Easy;
    cashbackType: CashbackType;
    isDealerMode: boolean;
    roles: IDealerModeRole[];

    constructor( model: IUserDto )
    {
        this.appConsumerId = model.appConsumerId;
        this.businessConsumerId = model.businessConsumerId;
        this.businessId = model.businessId;
        this.appName = model.appName;
        this.businessName = model.businessName;
        this.firstName = model.firstName;
        this.lastName = model.lastName;
        this.email = model.email;
        this.permissions = model.permissions;
        this.activeVehicle = this.getActiveVehicle();
        this.cashbackType = model.cashbackType ?? CashbackType.Unknown;
        this.isDealerMode = model.isDealerMode;
        this.roles = this.isDealerMode ? model.roles.filter( r => new DealerModeRole( r ) ) : [];

        // TODO: remove when added to backend
        const storedIsExpertMode = localStorage.getItem( 'expertMode' ) ?? 'false';
        this.appMode = storedIsExpertMode == 'true' ? AppMode.Expert : AppMode.Easy;

    }

    get fullName(): string
    {
        return `${this.firstName} ${this.lastName}`;
    }

    /**
     * True if the welcome flow needs to be displayed
     */
    get hasWelcomeFlow(): boolean
    {
        return false;
    }

    /**
     * Gets the active vehicle from local storage.  This will have been saved to local storage on authentication
     * @returns
     */
    private getActiveVehicle()
    {
        const storedVehicle = JSON.parse( localStorage.getItem( 'activeVehicle' ) ?? '{}' ) as IActiveVehicleDto;
        return new ActiveVehicle( storedVehicle );
    }

    /**
     * Provides a method for obtaining an object used for serialization in JSON.serialize methods.  Removes
     * the activeVehicle property as this is serialized seperately
     * @returns
     */
    toJSON()
    {
        const serialize = Object.assign( {}, this ) as any;
        delete serialize.activeVehicle;
        return serialize;
    }

    get isExpert()
    {
        return this.appMode == AppMode.Expert;
    }

    /**
     * Sets the appMode and saves the user settings
     */
    set isExpert( value: boolean )
    {
        this.appMode = value ? AppMode.Expert : AppMode.Easy;
        localStorage.setItem( 'expertMode', String( value ) );
        //const api = useCarbucksApi();
        //api.saveUserSettings( this );
    }

}
